export const DivShowAndHideTypes = {
   
    SHOW_RBL_KYC_SECTION:"SHOW_RBL_KYC_SECTION",
    SHOW_BIOMETRIC_SECTION:"SHOW_BIOMETRIC_SECTION",
    SHOW_RBL_OTP_VERIFY_SECTION:"SHOW_RBL_OTP_VERIFY_SECTION",

    SHOW_ICICI_ONBOARDING_SECTION:"SHOW_ICICI_ONBOARDING_SECTION",
    SHOW_ICICI_KYC_SECTION:"SHOW_ICICI_KYC_SECTION",
    SHOW_ICICI_KYC_SUCCESS_SECTION:"SHOW_ICICI_KYC_SUCCESS_SECTION",
    
    RESET: "RESET",
  };